import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A row of outdoor switchgear: three steel cubicles in a line on a low plinth,
// each with a door, a louvre vent and a small mimic/indicator panel. The
// metal-clad gear that switches and protects distribution feeders.
const BODY = "#9aa0a6";
const BODY_DK = "#7c8288";
const DOOR = "#878d93";
const PLINTH = "#5a5a5e";

function cubicle(x: number): Part[] {
  return [
    { geometry: new THREE.BoxGeometry(0.34, 0.5, 0.34), color: BODY, position: [x, 0.33, 0] },
    { geometry: new THREE.BoxGeometry(0.28, 0.4, 0.02), color: DOOR, position: [x, 0.31, 0.18] },
    // Door handle.
    { geometry: new THREE.BoxGeometry(0.02, 0.1, 0.02), color: "#3a3a3e", position: [x + 0.1, 0.31, 0.2] },
    // Louvre vent.
    { geometry: new THREE.BoxGeometry(0.16, 0.02, 0.02), color: BODY_DK, position: [x, 0.46, 0.19] },
    { geometry: new THREE.BoxGeometry(0.16, 0.02, 0.02), color: BODY_DK, position: [x, 0.42, 0.19] },
    // Indicator panel.
    { geometry: new THREE.BoxGeometry(0.08, 0.05, 0.02), color: "#3aa0d0", position: [x, 0.16, 0.19] },
  ];
}

export const switchgearCabinet = defineModel({
  id: "switchgear-cabinet",
  batchId: "electric",
  name: "Switchgear cabinet",
  tags: ["prop", "electric", "power", "grid", "switchgear", "distribution"],
  summary: "A row of metal-clad switchgear cubicles on a plinth.",
  footprint: 0.55,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(1.16, 0.1, 0.42), color: PLINTH, position: [0, 0.05, 0] },
      ...cubicle(-0.37),
      ...cubicle(0.0),
      ...cubicle(0.37),
      // Common roof cap.
      { geometry: new THREE.BoxGeometry(1.12, 0.04, 0.38), color: BODY_DK, position: [0, 0.6, 0] },
    ];
  },
  animations: [],
});
